import { Injectable } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { BatchActivityState, GlobalBatchActivityStore, ProjectBatchActivityStore, UserBatchActivityStore } from "./batchActivity.store";

@Injectable({
  providedIn: 'root'
})
export class GlobalBatchActivityQuery extends QueryEntity<BatchActivityState> {
  all$ = this.selectAll();

  constructor(protected store: GlobalBatchActivityStore) {
    super(store);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjectBatchActivityQuery extends QueryEntity<BatchActivityState> {
  all$ = this.selectAll();

  constructor(protected store: ProjectBatchActivityStore) {
    super(store);
  }  
}


@Injectable({
  providedIn: 'root'
})
export class UserBatchActivityQuery extends QueryEntity<BatchActivityState> {
  all$ = this.selectAll();

  constructor(protected store: UserBatchActivityStore) {
    super(store);
  }  
}


